/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
//LIBS


import header             from "./libs/header";
import videoVimeo         from "./libs/videoVimeo";
import animHome           from './libs/animHome.js';
import slider             from './libs/slider.js';
import product            from './libs/product.js';
import onglet             from './libs/onglet.js';
import headerParallax     from './libs/parallax.js';
import titlePicto         from './libs/titlePicto.js';
import animMarque         from './libs/animMarque.js';
import animatedPush       from './libs/animatedPush.js';
import animVideo          from './libs/animVideo.js';
import mainMenu           from './libs/mainMenu.js';
import needHelp           from './libs/needHelp.js';
import accordeon          from './libs/accordeon.js';
import cart               from './libs/cart.js';
import form               from './libs/form.js';
import auth               from './libs/Auth/auth.js';
import registration       from './libs/Auth/registration.js';
import password           from './libs/Auth/password.js';
import checkout           from './libs/checkout.js';
import productCat         from './libs/productCat.js';
import zenitech           from './libs/zenitech.js';
import 'alpinejs'


(function (Drupal, $) {

  'use strict';

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.otio = {

    attach: function (context, settings) {
      window.screenSize = $(window).width();
      if (context == document) {
          // cart.init();
          onglet.init();
          header.search();
          productCat.init();

          setTimeout(function(){
              accordeon.init();
              animHome.init();
              mainMenu.init();

          }, 0);
      }

      $(document).ready(function(){
        header.init();
        videoVimeo.init();
        needHelp.init();
        slider.init();
        product.init();
        headerParallax.init();
        titlePicto.init();
        animMarque.init();

        if(window.screenSize > 755){
          animatedPush.init();
        }
        animVideo.init();
        form.init();
        password.init();
        checkout.init();
        zenitech.init();
      })

      $(window).resize(function(){
        animHome.init();
        animatedPush.init();
        //mainMenu.init();
        headerParallax.init();
      })
    }
  };

  // Alpine js
  window.auth = auth;
  window.registration = registration;


  // We pass the parameters of this anonymous function are the global variables
  // that this script depend on. For example, if the above script requires
  // jQuery, you should change (Drupal) to (Drupal, jQuery) in the line below
  // and, in this file's first line of JS, change function (Drupal) to
  // (Drupal, $)
})(Drupal, jQuery);
